import { Component, Input, OnInit } from "@angular/core";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit {
  @Input() login: boolean = false;
  date = new Date().getFullYear();
  ccmDbVersion: string = '';
  rdmServerVersion: string = '';
  ccmServerVersion: string = '';

  constructor(private _service: ApiService) {

  }
  socialData: any
  ngOnInit(): void {
    let social = localStorage.getItem('socialData');
    if (social) {
      this.socialData = JSON.parse(social);
      this.rdmServerVersion = this.socialData.rdmServerVersion;
      this.ccmServerVersion = this.socialData.ccmServerVersion;
      this.ccmDbVersion = this.socialData.ccmDbVersion;
    }
  }
}
